// DS1.5
import React from 'react';
import c from 'classnames';
import s from './Logo.scss';
const Logo = ({ className, style, markColor = 'green', markColorClassname, textColor = 'black', textColorClassname, size = 'medium', withText = true })=>{
    return /*#__PURE__*/ React.createElement("div", {
        style: style
    }, !withText && /*#__PURE__*/ React.createElement("span", {
        className: c(s['mark'], markColorClassname || s[`mark-${markColor}`])
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        version: "1.1",
        width: "33",
        height: "30",
        viewBox: "0 0 33 30",
        preserveAspectRatio: "xMidYMid meet"
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_10_708)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 32.6205,
        height: 30,
        fill: "black"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 32.6205,
        height: 30,
        fill: "url(#paint0_radial_10_708)"
    }), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#filter0_d_10_708)"
    }, /*#__PURE__*/ React.createElement("g", {
        filter: "url(#filter1_d_10_708)"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.2091 2.22094C18.0821 2.35062 17.5262 3.32086 16.8627 4.57102L15.7326 6.70017L14.9741 7.19962L7 7.2L7.03317 13.6366L11.4699 13.6699L11.8112 14.113L7.00115 23.2213V27.8732H11.7781L12.0279 27.6199C12.1979 27.4475 12.6291 26.7035 13.3785 25.2894C14.4477 23.2721 14.4891 23.2054 14.8177 22.9744L15.1561 22.7366H23.2031V16.2683H18.8164L18.6403 16.0497C18.5435 15.9295 18.4642 15.7979 18.4642 15.7574C18.4642 15.7168 19.5305 13.6657 20.8337 11.1994L23.2031 6.7152V2H18.4253L18.2091 2.22094Z",
        fill: "url(#paint1_linear_10_708)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M18.3878 2.39579L18.3877 2.39585C18.3877 2.39583 18.3877 2.39588 18.3876 2.39601C18.3862 2.39766 18.3737 2.41231 18.3475 2.45017C18.322 2.48705 18.2896 2.53681 18.2505 2.5994C18.1725 2.72437 18.0721 2.89386 17.954 3.10008C17.7179 3.51212 17.4144 4.06473 17.0835 4.68822L16.8627 4.57102L17.0835 4.68823L15.9534 6.81738C15.9338 6.85441 15.9051 6.88591 15.8701 6.90897L15.1115 7.40842C15.0707 7.4353 15.0229 7.44962 14.9741 7.44962L7.25129 7.44999L7.2819 13.3885L11.4718 13.42C11.5487 13.4205 11.6211 13.4565 11.668 13.5174L12.0093 13.9604C12.069 14.0379 12.078 14.1432 12.0323 14.2297L7.25115 23.2833V27.6232H11.6735L11.8498 27.4444C11.8734 27.4205 11.9207 27.36 11.9961 27.2449C12.0686 27.1342 12.1594 26.9851 12.2696 26.7949C12.49 26.4147 12.7834 25.8785 13.1576 25.1723L13.3785 25.2894L13.1576 25.1723C13.6897 24.1683 13.9727 23.6371 14.1635 23.33C14.2604 23.1743 14.34 23.0653 14.4234 22.9776C14.5082 22.8885 14.5894 22.8293 14.674 22.7699L15.0123 22.5321C15.0544 22.5025 15.1046 22.4866 15.1561 22.4866H22.9531V16.5183H18.8164C18.7408 16.5183 18.6692 16.484 18.6217 16.4251L18.4456 16.2066L18.4456 16.2065L18.6403 16.0497C18.5435 15.9295 18.4642 15.7979 18.4642 15.7574C18.4642 15.7168 19.5305 13.6657 20.8337 11.1994L18.3878 2.39579ZM18.3878 2.39579L18.5304 2.25H22.9531V6.65321L18.3878 2.39579Z",
        stroke: "url(#paint2_linear_10_708)",
        strokeWidth: 0.5,
        strokeLinejoin: "round"
    }))), /*#__PURE__*/ React.createElement("g", {
        style: {
            mixBlendMode: 'screen'
        }
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M18.3878 2.39579L18.3877 2.39585C18.3877 2.39583 18.3877 2.39588 18.3876 2.39601C18.3862 2.39766 18.3737 2.41231 18.3475 2.45017C18.322 2.48705 18.2896 2.53681 18.2505 2.5994C18.1725 2.72437 18.0721 2.89386 17.954 3.10008C17.7179 3.51212 17.4144 4.06473 17.0835 4.68822L16.8627 4.57102L17.0835 4.68823L15.9534 6.81738C15.9338 6.85441 15.9051 6.88591 15.8701 6.90897L15.1115 7.40842C15.0707 7.4353 15.0229 7.44962 14.9741 7.44962L7.25129 7.44999L7.2819 13.3885L11.4718 13.42C11.5487 13.4205 11.6211 13.4565 11.668 13.5174L12.0093 13.9604C12.069 14.0379 12.078 14.1432 12.0323 14.2297L7.25115 23.2833V27.6232H11.6735L11.8498 27.4444C11.8734 27.4205 11.9207 27.36 11.9961 27.2449C12.0686 27.1342 12.1594 26.9851 12.2696 26.7949C12.49 26.4147 12.7834 25.8785 13.1576 25.1723L13.3785 25.2894L13.1576 25.1723C13.6897 24.1683 13.9727 23.6371 14.1635 23.33C14.2604 23.1743 14.34 23.0653 14.4234 22.9776C14.5082 22.8885 14.5894 22.8293 14.674 22.7699L15.0123 22.5321C15.0544 22.5025 15.1046 22.4866 15.1561 22.4866H22.9531V16.5183H18.8164C18.7408 16.5183 18.6692 16.484 18.6217 16.4251L18.4456 16.2066L18.4456 16.2065L18.6403 16.0497C18.5435 15.9295 18.4642 15.7979 18.4642 15.7574C18.4642 15.7168 19.5305 13.6657 20.8337 11.1994L18.3878 2.39579ZM18.3878 2.39579L18.5304 2.25H22.9531V6.65321L18.3878 2.39579Z",
        fill: "url(#paint3_linear_10_708)",
        fillOpacity: 0.4,
        stroke: "url(#paint4_linear_10_708)",
        strokeWidth: 0.5,
        strokeLinejoin: "round"
    })), /*#__PURE__*/ React.createElement("g", {
        style: {
            mixBlendMode: 'overlay'
        }
    }, /*#__PURE__*/ React.createElement("g", {
        filter: "url(#filter2_d_10_708)"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.2091 2.22094C18.0821 2.35062 17.5262 3.32086 16.8627 4.57102L15.7326 6.70017L14.9741 7.19962L7 7.2L7.03317 13.6366L11.4699 13.6699L11.8112 14.113L7.00115 23.2213V27.8732H11.7781L12.0279 27.6199C12.1979 27.4475 12.6291 26.7035 13.3785 25.2894C14.4477 23.2721 14.4891 23.2054 14.8177 22.9744L15.1561 22.7366H23.2031V16.2683H18.8164L18.6403 16.0497C18.5435 15.9295 18.4642 15.7979 18.4642 15.7574C18.4642 15.7168 19.5305 13.6657 20.8337 11.1994L23.2031 6.7152V2H18.4253L18.2091 2.22094Z",
        fill: "url(#paint5_linear_10_708)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M18.3878 2.39579L18.3877 2.39585C18.3877 2.39583 18.3877 2.39588 18.3876 2.39601C18.3862 2.39766 18.3737 2.41231 18.3475 2.45017C18.322 2.48705 18.2896 2.53681 18.2505 2.5994C18.1725 2.72437 18.0721 2.89386 17.954 3.10008C17.7179 3.51212 17.4144 4.06473 17.0835 4.68822L16.8627 4.57102L17.0835 4.68823L15.9534 6.81738C15.9338 6.85441 15.9051 6.88591 15.8701 6.90897L15.1115 7.40842C15.0707 7.4353 15.0229 7.44962 14.9741 7.44962L7.25129 7.44999L7.2819 13.3885L11.4718 13.42C11.5487 13.4205 11.6211 13.4565 11.668 13.5174L12.0093 13.9604C12.069 14.0379 12.078 14.1432 12.0323 14.2297L7.25115 23.2833V27.6232H11.6735L11.8498 27.4444C11.8734 27.4205 11.9207 27.36 11.9961 27.2449C12.0686 27.1342 12.1594 26.9851 12.2696 26.7949C12.49 26.4147 12.7834 25.8785 13.1576 25.1723L13.3785 25.2894L13.1576 25.1723C13.6897 24.1683 13.9727 23.6371 14.1635 23.33C14.2604 23.1743 14.34 23.0653 14.4234 22.9776C14.5082 22.8885 14.5894 22.8293 14.674 22.7699L15.0123 22.5321C15.0544 22.5025 15.1046 22.4866 15.1561 22.4866H22.9531V16.5183H18.8164C18.7408 16.5183 18.6692 16.484 18.6217 16.4251L18.4456 16.2066L18.4456 16.2065L18.6403 16.0497C18.5435 15.9295 18.4642 15.7979 18.4642 15.7574C18.4642 15.7168 19.5305 13.6657 20.8337 11.1994L18.3878 2.39579ZM18.3878 2.39579L18.5304 2.25H22.9531V6.65321L18.3878 2.39579Z",
        stroke: "url(#paint6_linear_10_708)",
        strokeWidth: 0.5,
        strokeLinejoin: "round"
    }))), /*#__PURE__*/ React.createElement("g", {
        style: {
            mixBlendMode: 'color-dodge'
        }
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 7,
        cy: 7,
        r: 4,
        fill: "url(#paint7_diamond_10_708)"
    })), /*#__PURE__*/ React.createElement("g", {
        style: {
            mixBlendMode: 'color-dodge'
        }
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 22.5,
        cy: 22.5,
        r: 4.5,
        fill: "url(#paint8_diamond_10_708)"
    }))), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
        id: "filter0_d_10_708",
        x: 5,
        y: 2,
        width: 20.2031,
        height: 29.8732,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dy: 2
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 1
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.130312 0 0 0 0 0.252035 0 0 0 0 0.166829 0 0 0 1 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_10_708"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_10_708",
        result: "shape"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "filter1_d_10_708",
        x: 5,
        y: 2,
        width: 20.2031,
        height: 29.8732,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dy: 2
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 1
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.130312 0 0 0 0 0.252035 0 0 0 0 0.166829 0 0 0 1 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_10_708"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_10_708",
        result: "shape"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "filter2_d_10_708",
        x: 3,
        y: 2,
        width: 24.2031,
        height: 33.8732,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dy: 4
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 2
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.294767 0 0 0 0 0.317822 0 0 0 0 0.301683 0 0 0 1 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_10_708"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_10_708",
        result: "shape"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint0_radial_10_708",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(16.3103 15) rotate(90) scale(15 16.3103)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#637C56"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#314537"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_10_708",
        x1: 93,
        y1: 28,
        x2: 93.7108,
        y2: 2,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.0104167,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.161797,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.508601,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.722586,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.78,
        stopColor: "#6A4800"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.81851,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.9999,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint2_linear_10_708",
        x1: 15.1016,
        y1: 2,
        x2: 15.1016,
        y2: 27.8732,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104167,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.697917,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854167,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint3_linear_10_708",
        x1: 93.7108,
        y1: 28,
        x2: 93.7108,
        y2: 2,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.0104167,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.0416667,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828125,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.9375,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979167,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.9999,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint4_linear_10_708",
        x1: 15.1016,
        y1: 2,
        x2: 15.1016,
        y2: 27.8732,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104167,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.697917,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854167,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint5_linear_10_708",
        x1: 20.5343,
        y1: 27.8732,
        x2: 19.2019,
        y2: 6.55929,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.0104167,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.0416667,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828125,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.9375,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979167,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.9999,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint6_linear_10_708",
        x1: 15.1016,
        y1: 2,
        x2: 15.1016,
        y2: 27.8732,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104167,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.697917,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854167,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint7_diamond_10_708",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(7 7) rotate(90) scale(4)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFFFA5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint8_diamond_10_708",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(22.5 22.5) rotate(90) scale(4.5)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFFFA5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_10_708"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 32.6205,
        height: 30,
        fill: "white"
    }))))), withText && /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 132,
        height: 54,
        fill: "none"
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M0 0h132v54H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#b)",
        d: "M0 0h132v54H0z"
    }), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#c)"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "i",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463-.347.652-.631 1.202-.631 1.221 0 .02.284.035.631.035 1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.623-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14l-.143.278ZM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03v11.605Zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745c1.671-3.16 3.048-5.772 3.06-5.803.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08V25.62Zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207.35 3207.35 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765-.757-3.135-1.376-5.715-1.376-5.736 0-.02-.848-.037-1.885-.037h-1.884l-.35.65Zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002V25.62Zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731v3.043Zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232.018.017.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034-.139.27Zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04V39.89Zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731v3.044Zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182ZM45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037 0-.02.097-.213.216-.428.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253ZM29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293 0-.04 1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779l-.216.22Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 37.354 3.888-3.33c.432-.36.756-.666.972-.918.228-.252.384-.474.468-.666a1.64 1.64 0 0 0 .126-.63c0-.312-.15-.582-.45-.81-.3-.24-.768-.36-1.404-.36-.588 0-1.146.072-1.674.216a8.346 8.346 0 0 0-1.692.648l-.18-2.772a8.816 8.816 0 0 1 1.98-.774 8.422 8.422 0 0 1 2.214-.288c1.464 0 2.604.348 3.42 1.044.828.696 1.242 1.62 1.242 2.772 0 .792-.234 1.518-.702 2.178-.456.648-1.11 1.332-1.962 2.052l-1.656 1.404h4.572V40h-9.162v-2.646ZM91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40h-3.15Z"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#d)",
        fillRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463-.347.652-.631 1.202-.631 1.221 0 .02.284.035.631.035 1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.623-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14l-.143.278ZM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03v11.605Zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745c1.671-3.16 3.048-5.772 3.06-5.803.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08V25.62Zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207.35 3207.35 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765-.757-3.135-1.376-5.715-1.376-5.736 0-.02-.848-.037-1.885-.037h-1.884l-.35.65Zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002V25.62Zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731v3.043Zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232.018.017.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034-.139.27Zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04V39.89Zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731v3.044Zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182ZM45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037 0-.02.097-.213.216-.428.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#e)",
        fillRule: "evenodd",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293 0-.04 1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779l-.216.22Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#f)",
        d: "m75.756 37.354 3.888-3.33c.432-.36.756-.666.972-.918.228-.252.384-.474.468-.666a1.64 1.64 0 0 0 .126-.63c0-.312-.15-.582-.45-.81-.3-.24-.768-.36-1.404-.36-.588 0-1.146.072-1.674.216a8.346 8.346 0 0 0-1.692.648l-.18-2.772a8.816 8.816 0 0 1 1.98-.774 8.422 8.422 0 0 1 2.214-.288c1.464 0 2.604.348 3.42 1.044.828.696 1.242 1.62 1.242 2.772 0 .792-.234 1.518-.702 2.178-.456.648-1.11 1.332-1.962 2.052l-1.656 1.404h4.572V40h-9.162v-2.646Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#g)",
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40h-3.15Z"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#h)",
        strokeLinejoin: "round",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463-.347.652-.631 1.202-.631 1.221 0 .02.284.035.631.035 1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.623-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14l-.143.278ZM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03v11.605Zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745c1.671-3.16 3.048-5.772 3.06-5.803.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08V25.62Zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207.35 3207.35 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765-.757-3.135-1.376-5.715-1.376-5.736 0-.02-.848-.037-1.885-.037h-1.884l-.35.65Zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002V25.62Zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731v3.043Zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232.018.017.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034-.139.27Zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04V39.89Zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731v3.044Zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182ZM45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037 0-.02.097-.213.216-.428.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253Z",
        clipRule: "evenodd",
        mask: "url(#i)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#j)",
        strokeLinejoin: "round",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293 0-.04 1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779l-.216.22Z",
        clipRule: "evenodd",
        mask: "url(#i)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#k)",
        strokeLinejoin: "round",
        d: "m75.756 37.354 3.888-3.33c.432-.36.756-.666.972-.918.228-.252.384-.474.468-.666a1.64 1.64 0 0 0 .126-.63c0-.312-.15-.582-.45-.81-.3-.24-.768-.36-1.404-.36-.588 0-1.146.072-1.674.216a8.346 8.346 0 0 0-1.692.648l-.18-2.772a8.816 8.816 0 0 1 1.98-.774 8.422 8.422 0 0 1 2.214-.288c1.464 0 2.604.348 3.42 1.044.828.696 1.242 1.62 1.242 2.772 0 .792-.234 1.518-.702 2.178-.456.648-1.11 1.332-1.962 2.052l-1.656 1.404h4.572V40h-9.162v-2.646Z",
        mask: "url(#i)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#l)",
        strokeLinejoin: "round",
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40h-3.15Z",
        mask: "url(#i)"
    })), /*#__PURE__*/ React.createElement("g", {
        style: {
            mixBlendMode: 'screen'
        }
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "r",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463-.347.652-.631 1.202-.631 1.221 0 .02.284.035.631.035 1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.623-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14l-.143.278ZM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03v11.605Zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745c1.671-3.16 3.048-5.772 3.06-5.803.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08V25.62Zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207.35 3207.35 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765-.757-3.135-1.376-5.715-1.376-5.736 0-.02-.848-.037-1.885-.037h-1.884l-.35.65Zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002V25.62Zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731v3.043Zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232.018.017.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034-.139.27Zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04V39.89Zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731v3.044Zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182ZM45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037 0-.02.097-.213.216-.428.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253ZM29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293 0-.04 1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779l-.216.22Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 37.354 3.888-3.33c.432-.36.756-.666.972-.918.228-.252.384-.474.468-.666a1.64 1.64 0 0 0 .126-.63c0-.312-.15-.582-.45-.81-.3-.24-.768-.36-1.404-.36-.588 0-1.146.072-1.674.216a8.346 8.346 0 0 0-1.692.648l-.18-2.772a8.816 8.816 0 0 1 1.98-.774 8.422 8.422 0 0 1 2.214-.288c1.464 0 2.604.348 3.42 1.044.828.696 1.242 1.62 1.242 2.772 0 .792-.234 1.518-.702 2.178-.456.648-1.11 1.332-1.962 2.052l-1.656 1.404h4.572V40h-9.162v-2.646ZM91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40h-3.15Z"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#m)",
        fillOpacity: 0.4,
        fillRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463-.347.652-.631 1.202-.631 1.221 0 .02.284.035.631.035 1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.623-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14l-.143.278ZM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03v11.605Zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745c1.671-3.16 3.048-5.772 3.06-5.803.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08V25.62Zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207.35 3207.35 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765-.757-3.135-1.376-5.715-1.376-5.736 0-.02-.848-.037-1.885-.037h-1.884l-.35.65Zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002V25.62Zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731v3.043Zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232.018.017.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034-.139.27Zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04V39.89Zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731v3.044Zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182ZM45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037 0-.02.097-.213.216-.428.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#n)",
        fillOpacity: 0.4,
        fillRule: "evenodd",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293 0-.04 1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779l-.216.22Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#o)",
        fillOpacity: 0.4,
        d: "m75.756 37.354 3.888-3.33c.432-.36.756-.666.972-.918.228-.252.384-.474.468-.666a1.64 1.64 0 0 0 .126-.63c0-.312-.15-.582-.45-.81-.3-.24-.768-.36-1.404-.36-.588 0-1.146.072-1.674.216a8.346 8.346 0 0 0-1.692.648l-.18-2.772a8.816 8.816 0 0 1 1.98-.774 8.422 8.422 0 0 1 2.214-.288c1.464 0 2.604.348 3.42 1.044.828.696 1.242 1.62 1.242 2.772 0 .792-.234 1.518-.702 2.178-.456.648-1.11 1.332-1.962 2.052l-1.656 1.404h4.572V40h-9.162v-2.646Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#p)",
        fillOpacity: 0.4,
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40h-3.15Z"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#q)",
        strokeLinejoin: "round",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463-.347.652-.631 1.202-.631 1.221 0 .02.284.035.631.035 1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.623-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14l-.143.278ZM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03v11.605Zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745c1.671-3.16 3.048-5.772 3.06-5.803.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08V25.62Zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207.35 3207.35 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765-.757-3.135-1.376-5.715-1.376-5.736 0-.02-.848-.037-1.885-.037h-1.884l-.35.65Zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002V25.62Zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731v3.043Zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232.018.017.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034-.139.27Zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04V39.89Zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731v3.044Zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182ZM45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037 0-.02.097-.213.216-.428.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253Z",
        clipRule: "evenodd",
        mask: "url(#r)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#s)",
        strokeLinejoin: "round",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293 0-.04 1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779l-.216.22Z",
        clipRule: "evenodd",
        mask: "url(#r)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#t)",
        strokeLinejoin: "round",
        d: "m75.756 37.354 3.888-3.33c.432-.36.756-.666.972-.918.228-.252.384-.474.468-.666a1.64 1.64 0 0 0 .126-.63c0-.312-.15-.582-.45-.81-.3-.24-.768-.36-1.404-.36-.588 0-1.146.072-1.674.216a8.346 8.346 0 0 0-1.692.648l-.18-2.772a8.816 8.816 0 0 1 1.98-.774 8.422 8.422 0 0 1 2.214-.288c1.464 0 2.604.348 3.42 1.044.828.696 1.242 1.62 1.242 2.772 0 .792-.234 1.518-.702 2.178-.456.648-1.11 1.332-1.962 2.052l-1.656 1.404h4.572V40h-9.162v-2.646Z",
        mask: "url(#r)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#u)",
        strokeLinejoin: "round",
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40h-3.15Z",
        mask: "url(#r)"
    })), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#v)",
        style: {
            mixBlendMode: 'overlay'
        }
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "B",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463-.347.652-.631 1.202-.631 1.221 0 .02.284.035.631.035 1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.623-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14l-.143.278ZM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03v11.605Zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745c1.671-3.16 3.048-5.772 3.06-5.803.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08V25.62Zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207.35 3207.35 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765-.757-3.135-1.376-5.715-1.376-5.736 0-.02-.848-.037-1.885-.037h-1.884l-.35.65Zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002V25.62Zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731v3.043Zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232.018.017.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034-.139.27Zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04V39.89Zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731v3.044Zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182ZM45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037 0-.02.097-.213.216-.428.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253ZM29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293 0-.04 1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779l-.216.22Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 37.354 3.888-3.33c.432-.36.756-.666.972-.918.228-.252.384-.474.468-.666a1.64 1.64 0 0 0 .126-.63c0-.312-.15-.582-.45-.81-.3-.24-.768-.36-1.404-.36-.588 0-1.146.072-1.674.216a8.346 8.346 0 0 0-1.692.648l-.18-2.772a8.816 8.816 0 0 1 1.98-.774 8.422 8.422 0 0 1 2.214-.288c1.464 0 2.604.348 3.42 1.044.828.696 1.242 1.62 1.242 2.772 0 .792-.234 1.518-.702 2.178-.456.648-1.11 1.332-1.962 2.052l-1.656 1.404h4.572V40h-9.162v-2.646ZM91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40h-3.15Z"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#w)",
        fillRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463-.347.652-.631 1.202-.631 1.221 0 .02.284.035.631.035 1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.623-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14l-.143.278ZM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03v11.605Zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745c1.671-3.16 3.048-5.772 3.06-5.803.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08V25.62Zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207.35 3207.35 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765-.757-3.135-1.376-5.715-1.376-5.736 0-.02-.848-.037-1.885-.037h-1.884l-.35.65Zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002V25.62Zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731v3.043Zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232.018.017.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034-.139.27Zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04V39.89Zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731v3.044Zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182ZM45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037 0-.02.097-.213.216-.428.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#x)",
        fillRule: "evenodd",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293 0-.04 1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779l-.216.22Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#y)",
        d: "m75.756 37.354 3.888-3.33c.432-.36.756-.666.972-.918.228-.252.384-.474.468-.666a1.64 1.64 0 0 0 .126-.63c0-.312-.15-.582-.45-.81-.3-.24-.768-.36-1.404-.36-.588 0-1.146.072-1.674.216a8.346 8.346 0 0 0-1.692.648l-.18-2.772a8.816 8.816 0 0 1 1.98-.774 8.422 8.422 0 0 1 2.214-.288c1.464 0 2.604.348 3.42 1.044.828.696 1.242 1.62 1.242 2.772 0 .792-.234 1.518-.702 2.178-.456.648-1.11 1.332-1.962 2.052l-1.656 1.404h4.572V40h-9.162v-2.646Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#z)",
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40h-3.15Z"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#A)",
        strokeLinejoin: "round",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463-.347.652-.631 1.202-.631 1.221 0 .02.284.035.631.035 1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.623-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14l-.143.278ZM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03v11.605Zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745c1.671-3.16 3.048-5.772 3.06-5.803.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08V25.62Zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207.35 3207.35 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765-.757-3.135-1.376-5.715-1.376-5.736 0-.02-.848-.037-1.885-.037h-1.884l-.35.65Zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002V25.62Zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731v3.043Zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232.018.017.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034-.139.27Zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04V39.89Zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731v3.044Zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182ZM45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037 0-.02.097-.213.216-.428.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253Z",
        clipRule: "evenodd",
        mask: "url(#B)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#C)",
        strokeLinejoin: "round",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293 0-.04 1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779l-.216.22Z",
        clipRule: "evenodd",
        mask: "url(#B)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#D)",
        strokeLinejoin: "round",
        d: "m75.756 37.354 3.888-3.33c.432-.36.756-.666.972-.918.228-.252.384-.474.468-.666a1.64 1.64 0 0 0 .126-.63c0-.312-.15-.582-.45-.81-.3-.24-.768-.36-1.404-.36-.588 0-1.146.072-1.674.216a8.346 8.346 0 0 0-1.692.648l-.18-2.772a8.816 8.816 0 0 1 1.98-.774 8.422 8.422 0 0 1 2.214-.288c1.464 0 2.604.348 3.42 1.044.828.696 1.242 1.62 1.242 2.772 0 .792-.234 1.518-.702 2.178-.456.648-1.11 1.332-1.962 2.052l-1.656 1.404h4.572V40h-9.162v-2.646Z",
        mask: "url(#B)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#E)",
        strokeLinejoin: "round",
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40h-3.15Z",
        mask: "url(#B)"
    })), /*#__PURE__*/ React.createElement("circle", {
        cx: 18,
        cy: 20,
        r: 7,
        fill: "url(#F)",
        style: {
            mixBlendMode: 'color-dodge'
        }
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 34,
        cy: 35,
        r: 4,
        fill: "url(#G)",
        style: {
            mixBlendMode: 'color-dodge'
        }
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 92,
        cy: 28,
        r: 4,
        fill: "url(#H)",
        style: {
            mixBlendMode: 'color-dodge'
        }
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 84.5,
        cy: 14.5,
        r: 3.5,
        fill: "url(#I)",
        style: {
            mixBlendMode: 'color-dodge'
        }
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "d",
        x1: 104,
        x2: 104.711,
        y1: 40,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.162,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.509,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.723,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.78,
        stopColor: "#6A4800"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.819,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "e",
        x1: 104,
        x2: 104.711,
        y1: 40,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.162,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.509,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.723,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.78,
        stopColor: "#6A4800"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.819,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "f",
        x1: 104,
        x2: 104.711,
        y1: 40,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.162,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.509,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.723,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.78,
        stopColor: "#6A4800"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.819,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "g",
        x1: 104,
        x2: 104.711,
        y1: 40,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.162,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.509,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.723,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.78,
        stopColor: "#6A4800"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.819,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "h",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "j",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "k",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "l",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "m",
        x1: 104.711,
        x2: 104.711,
        y1: 40,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "n",
        x1: 104.711,
        x2: 104.711,
        y1: 40,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "o",
        x1: 104.711,
        x2: 104.711,
        y1: 40,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "p",
        x1: 104.711,
        x2: 104.711,
        y1: 40,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "q",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "s",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "t",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "u",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "w",
        x1: 104.711,
        x2: 104.5,
        y1: 40,
        y2: 18.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "x",
        x1: 104.711,
        x2: 104.5,
        y1: 40,
        y2: 18.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "y",
        x1: 104.711,
        x2: 104.5,
        y1: 40,
        y2: 18.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "z",
        x1: 104.711,
        x2: 104.5,
        y1: 40,
        y2: 18.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "A",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "C",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "D",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "E",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "b",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(0 27 -66 0 66 27)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#637C56"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#314537"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "F",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(0 7 -7 0 18 20)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFE7AA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "G",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(0 4 -4 0 34 35)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFFFA5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "H",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(0 4 -4 0 92 28)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFFF89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "I",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(90 35 49.5) scale(3.5)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFFF8A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "c",
        width: 107.809,
        height: 30,
        x: 16,
        y: 14,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dy: 2
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 1
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0.130312 0 0 0 0 0.252035 0 0 0 0 0.166829 0 0 0 1 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_3_505"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_3_505",
        result: "shape"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "v",
        width: 111.809,
        height: 34,
        x: 14,
        y: 14,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dy: 4
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 2
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0.294767 0 0 0 0 0.317822 0 0 0 0 0.301683 0 0 0 1 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_3_505"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_3_505",
        result: "shape"
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h132v54H0z"
    }))))));
};
Logo.displayName = 'Logo';
export default Logo;

//# sourceMappingURL=Logo.dabirthday_24.green.js.map